import { ErrorAppComponent } from 'modules/global/pods/error-app';

export const ErrorScene = () => <ErrorAppComponent />;

export default ErrorScene;
